<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-title-section">
      <h1><mat-icon>precision_manufacturing</mat-icon> Montadoras (OES)</h1>
      <p class="page-subtitle">Gerencie as montadoras cadastradas no sistema</p>
    </div>

    <!-- Filters -->
    <div class="filter-section">
      <div class="filter-header">
        <mat-icon>tune</mat-icon>
        Filtros de Pesquisa
      </div>
      <div class="filter-body">
        <form [formGroup]="filterForm">
          <div class="filter-grid cols-5">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Código</mat-label>
            <input matInput type="text" formControlName="code" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Nome Fantasia</mat-label>
            <input matInput type="text" formControlName="tradeName" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Razão Social</mat-label>
            <input matInput type="text" formControlName="companyName" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>CNPJ</mat-label>
            <input matInput type="text" formControlName="document" mask="AA.AAA.AAA/0000-00" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Status</mat-label>
            <mat-select placeholder="Selecione o status" formControlName="status">
              <mat-option value="AF">Ativas</mat-option>
              <mat-option value="IF">Inativas</mat-option>
            </mat-select>
          </mat-form-field>
          </div>
        </form>
      </div>
      <div class="filter-footer">
        <div class="filter-footer-left">
          <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
            <mat-icon>search</mat-icon><span>Buscar</span>
          </button>
          <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
            <mat-icon>refresh</mat-icon><span>Limpar</span>
          </button>
        </div>
        <div class="filter-footer-right">
          <button mat-flat-button color="primary" class="mic-btn-icon-left" routerLink="/automakers/create">
            <mat-icon>add_circle</mat-icon><span>Cadastrar</span>
          </button>
          <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="exportExcel()">
            <mat-icon>cloud_download</mat-icon><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-section">
      <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micCellTemplate="let item; name: 'activeCell'">
          @if (item.status === 'A') {
            <mat-icon>check</mat-icon>
          }
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'actionsCell'">
          <div class="flex flex-row gap-4">
            <button
              mat-icon-button
              color="primary"
              matTooltipClass="big-tooltip"
              matTooltip="Exportar Pedidos"
              (click)="openExportFilesModal(item)"
            >
              <mat-icon>arrow_circle_down</mat-icon>
            </button>
            <button
              mat-icon-button
              color="primary"
              matTooltipClass="big-tooltip"
              matTooltip="Importar Pedidos"
              (click)="redirectToImportOrders(item)"
            >
              <mat-icon>arrow_circle_up</mat-icon>
            </button>
            <button
              mat-icon-button
              color="primary"
              matTooltipClass="big-tooltip"
              matTooltip="Tabela de Preços"
              (click)="redirectToPriceTable(item)"
            >
              <mat-icon>description</mat-icon>
            </button>
            <button
              mat-icon-button
              color="primary"
              matTooltipClass="big-tooltip"
              matTooltip="Editar Montadora"
              (click)="redirectToEdit(item)"
            >
              <mat-icon>edit_square</mat-icon>
            </button>
          </div>
        </ng-container>
      </mic-table>
    </div>
  </div>
</mic-spinner-overlay>

<!-- Modal de Exportação de Arquivos -->
<app-export-files-modal #exportFilesModal></app-export-files-modal>
